// TeamEventList.js
import React, { useState } from 'react';
import { useTeamEvents } from './useTeamEvents';
import { Modal, Button } from 'react-bootstrap';

export const TeamEventList = ({ teamId }) => {
  const { events, loading } = useTeamEvents(teamId);
  const [selectedEvent, setSelectedEvent] = useState(null);

  if (loading) return <div>Loading events...</div>;

  const resolveAuthor = (event) => {
    if (!event) return '—';
    const direct =
      event.displayScreenName ||
      event.displayScreenname ||
      event.screenName ||
      event.screen_name ||
      event.ScreenName ||
      event.KnownAs ||
      event.knownAs ||
      event.known_as;
    if (direct) return direct;

    const composedTitle = event.displayTitle || event.title;
    if (typeof composedTitle === 'string') {
      const separatorIndex = composedTitle.lastIndexOf(' - ');
      if (separatorIndex !== -1) {
        const author = composedTitle.substring(separatorIndex + 3).trim();
        if (author) return author;
      }
    }

    return '—';
  };

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });

  const formatTime = (dateStr) =>
    new Date(dateStr).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  return (
    <div>
      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th>Title</th>
            <th>Author</th>
            <th>Date</th>
            <th>Time</th>
            <th>Type</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {events.map((event) => (
            <tr key={event.id}>
              <td>{event.displayTitle || event.title}</td>
              <td>{resolveAuthor(event)}</td>
              <td>{formatDate(event.start)}</td>
              <td>
                {event.allDay
                  ? 'All Day'
                  : `${formatTime(event.start)} - ${formatTime(event.end)}`}
              </td>
              <td>
                {event.source === 'calendar_event'
                  ? <span className="badge bg-success">Shared</span>
                  : <span className="badge bg-secondary">Internal</span>}
              </td>
              <td>
                <button className="btn btn-sm btn-outline-primary" onClick={() => setSelectedEvent(event)}>
                  View Details
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal for event details */}
      <Modal show={!!selectedEvent} onHide={() => setSelectedEvent(null)}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedEvent?.displayTitle || selectedEvent?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedEvent && (
            <>
              <p><strong>Date:</strong> {formatDate(selectedEvent.start)}</p>
              {!selectedEvent.allDay && (
                <p><strong>Time:</strong> {formatTime(selectedEvent.start)} - {formatTime(selectedEvent.end)}</p>
              )}
              {selectedEvent.location && (
                <p><strong>Location:</strong> {selectedEvent.location}</p>
              )}
              <p><strong>Organizer:</strong> {selectedEvent.createdBy || 'Unknown'}</p>
              <p>
                <strong>Type:</strong> {selectedEvent.source === 'calendar_event'
                  ? '📤 Shared with calendars'
                  : '🗒️ Internal team event'}
              </p>
              {selectedEvent.source === 'calendar_event' && selectedEvent.attendees?.length > 0 && (
                <div>
                  <strong>Participants:</strong>
                  <ul>
                    {selectedEvent.attendees.map((email, idx) => (
                      <li key={idx}>{email}</li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {selectedEvent?.projectCategoryId && (
            <a
              href={`http://zynity_yii.test/highlights/index/?category_id=${selectedEvent.projectCategoryId}`}
              className="btn btn-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              View in Project App
            </a>
          )}
          <Button variant="secondary" onClick={() => setSelectedEvent(null)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TeamEventList;
